<style lang="less">
.searchpage {
  padding-top: 52px;
  div {
    margin: 0;
  }
  .flodpanl {
    position: relative;
    padding: 0 20px 20px 20px;
    display: flex;
    > div {
      margin-right: 10px;
    }
  }

  .selnodes {
    position: relative;
  }

  .loadmore {
    height: 30px;
  }
}
</style>
<template>
  <div class="searchpage">
    <Search @onSerach="onSerach" />
    <div class="flodpanl">
      <template v-for="(item,i) in seles">
        <div @click="postData1(item, i)" :key="i">
          <SelectPop :text="item.lable" :active="item.active" />
        </div>
      </template>
    </div>
    <div class="selnodes">
      <SelTreeNodes ref="SelTreeNodes" @onSel="onSel" />
    </div>

    <div class="list">
      <template v-for="(item, i) in list">
        <Item :key="i" :row="item" />
      </template>

      <div class="loadmore" ref="loadmore"></div>
    </div>
  </div>
</template>
<script>
import mapStore from "@/mixins/mapStore";
import { cloneDeep } from "lodash";
import Search from "./Search";
import SelectPop from "./SelectPop";
import SelTreeNodes from "./TreeNodes";
import Item from "./Item";
import { GetPositionList, GetPositionCategory } from "@/api/api";
export default {
  components: { Search, SelectPop, SelTreeNodes, Item },
  mixins: [
    mapStore("", {
      getters: ["lang", "china"],
    }),
  ],
  data() {
    return {
      posiData: [],
      cityData: [
        {
          check: false,
          label: "不限",
          val: null,
        },
        {
          check: false,
          label: "重庆",
          val: '重庆',
        },
        {
          check: false,
          label: "北京",
          val: '北京',
        },
        {
          check: false,
          label: "上海",
          val: '上海',
        },
      ],
      typeData: [
        {
          check: false,
          label: "不限",
          val: null,
        },
        {
          check: false,
          label: "社招",
          val: 0,
        },
        {
          check: false,
          label: "校招",
          val: 1,
        },
      ],

      sels: [
        {
          lable: "职位类别",
          val: "职位类别",
          active: false,
        },
        {
          lable: "城市",
          val: "城市",
          active: false,
        },
        {
          lable: "招聘类型",
          val: -1,
          active: false,
        },
      ],
      openSel: null,
      openSelIdx: null,

      geting: false,
      isAll: false,

      searchInput: "",
      pageIndex: 0,
      pageSize: 20,
      total: 0,
      list: [],
    };
  },
  created() {
    this.getData();
    this.GetPositionCategory();
    this.loadScroll();
  },
  mounted() {
    console.log(this.lang)
  },
  computed: {
    seles() {
      var { join } = this.lang || {};
      var sels = [
        {
          lable: join.posiType,
          val: join.posiType,
          active: false,
        },
        {
          lable: join.city,
          val: join.city,
          active: false,
        },
        {
          lable: join.type,
          val: -1,
          active: false,
        },
      ];
      return sels
    },
  },
  methods: {
    GetPositionCategory() {
      GetPositionCategory()
        .then(res => {
          var { code, data } = res;
          if (code === 0) {
            console.log(data)

            var posiData = [{
              check: false,
              label: "不限",
              val: null
            }];
            for (let i = 0; i < data.length; i++) {
              var row = data[i];

              var obj = {
                check: false,
                label: row.categoryName,
                val: row.categoryName,
              };

              if (row.positions && row.positions.length > 0) {
                obj.child = [];
                for (let ii = 0; ii < row.positions.length; ii++) {
                  var item = row.positions[ii];
                  obj.child.push({
                    check: false,
                    label: item.name,
                    val: item.name,
                  })
                }
              }
              posiData.push(obj);
            }

            this.posiData = posiData;
          }
        })
    },


    postData1(item, i) {
      this.openSel = item;
      this.openSelIdx = i;
      this.posiActive = true;
      var SelTreeNodes = this.$refs.SelTreeNodes;

      if (i == 0) {
        SelTreeNodes.show(cloneDeep(this.posiData));
      } else if (i == 1) {
        SelTreeNodes.show(cloneDeep(this.cityData));
      } else if (i == 2) {
        SelTreeNodes.show(cloneDeep(this.typeData));
      }
    },

    onSel(item) {
      var { sels, openSelIdx } = this;
      sels[openSelIdx].lable = item.label;
      sels[openSelIdx].val = item.val;
      sels[openSelIdx].active = true;

      this.pageIndex = 0;
      this.isAll = false;
      this.list = [];

      // console.log(kw);
      // this.pageIndex = 0;
      this.getData();
    },

    onSerach(kw) {
      console.log(kw);
      this.pageIndex = 0;
      this.searchInput = kw;
      this.list = [];
      this.isAll = false;

      this.getData();
    },

    getData() {

      if (this.geting) {
        return false;
      }

      var { pageIndex, pageSize, searchInput, sels } = this;

      var pars = {
        pageIndex, pageSize,
        type: -1
      };
      if (searchInput) {
        pars.name = searchInput
      }
      if (sels[0].active) {
        pars.category = sels[0].val;
      }
      if (sels[1].active) {
        pars.city = sels[1].val;
      }
      if (sels[2].active) {
        pars.type = sels[2].val;
      }


      this.geting = true;
      GetPositionList(pars)
        .then((res) => {
          console.log(res);
          var { code, data } = res;
          if (code === 0) {
            var { dataCount } = data || {};
            var list = data.data || [];
            this.list = [...this.list, ...list];
            this.total = dataCount;

            if (list.length < pageSize) {
              this.isAll = true;
            }
          }
        })
        .finally(() => {
          this.geting = false;
        })
    },


    loadScroll() {
      var that = this;

      window.onscroll = () => {
        // console.log(e)
        var loadmore = this.$refs.loadmore;
        var wh = window.screen.availHeight;
        var { top } = loadmore.getBoundingClientRect();

        // console.log(top, wh, top - 100 < wh)

        if (top - 100 < wh && !this.geting && !this.isAll) {
          that.pageIndex++;
          that.getData()
        }
      };
    }
  },
};
</script>
